function normalizedCourseType(course) {
  return String(course?.course_type ?? course?.type ?? '').trim().toLowerCase();
}

export function isAssessmentCourse(course) {
  return course?.is_assessment === true || normalizedCourseType(course) === 'assessment';
}

export function isLiveCourse(course) {
  return normalizedCourseType(course) === 'live';
}

export function isOnlineLessonCourse(course) {
  const type = normalizedCourseType(course);
  return type === '' || type === 'regular' || type === 'online' || type === 'challenging';
}
